import React, { useEffect } from "react";

const BookMeetingWidget = () => {
  useEffect(() => {
    // Load HubSpot script
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/8383798.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div class="hs-form-frame" data-region="na1" data-form-id="2d4d79aa-7f50-4623-8b21-8cf2264f59fa" data-portal-id="8383798"></div>
  );
};

export default BookMeetingWidget;
